import React, { useState, useEffect, useCallback } from "react";
import SingleChatSideBarHeader from "../../../Components/MainChatSideBarHeader/SingleChatSideBarHeader";
import ChatListItem from "./GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListItem/ChatListItem";
import ChatListHeader from "./GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListHeader/ChatListHeader";
import SelectedChatAvatars from "./GroupChatList/GroupChatsSectionListItems/GroupChatSections/SelectedChatAvatars/SelectedChatAvatars";
import ChatListFooter from "./GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListFooter/ChatListFooter";
import AddChannel from "./GroupChatHeader/AddChannel/AddChannel";
import CreateChannel from "./GroupChatList/GroupChatsSectionListItems/NewChannelSections/CreateChannel/CreateChannel";
import ChannelUpload from "./GroupChatList/GroupChatsSectionListItems/NewChannelSections/ChannelUpload/ChannelUpload";
import AddSubscriber from "./GroupChatHeader/AddSubscriber/AddSubscriber";
import ChannelType from "./GroupChatList/GroupChatsSectionListItems/NewChannelSections/ChannelType/ChannelType";
import GroupChatSearch from "./GroupChatSearch/GroupChatSearch";
import ActiveChatList from "./GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListItem/ActiveChatList";
import AllUserList from "../../../Components/AllUserList/AllUserList";
import { toast } from "react-toastify";
import {
  getApiCaller,
  postApiCaller,
  postFormDataApiCaller,
} from "../../../Libs/apiCaller";
import { FadeLoader } from "react-spinners";
import {
  decryptMessage,
  decryptText,
} from "../../../Components/EncryptDecryptMessage/EncryptDecryptMessage";
import { useSelector } from "react-redux";
import InfiniteScroll from "../../../Components/InfiniteScroll/InfiniteScroll";

export default function ChannelSidebar({
  AllUser,
  onChannelSelect,
  channelActiveChat,
  currentPage,
  totalPages,
  fetchChannels,
  isLoading,
  channels,
  fetchAllUser,
  userSearch,
  search,
  allUserCurrentPage,
  allUserTotalPages,
  setIsMessageLoading,
}) {
  const { userInfo } = useSelector((state) => state.authUser);
  const [moreNewChat, setMoreNewChat] = useState(false);
  const [selectedChats, setSelectedChats] = useState([]);
  const [createNewChannelSection, setCreateNewChannelSection] = useState(0);
  const [newChannel, setNewChannel] = useState({
    channelName: "",
    description: "",
    image: null,
    isPublic: false,
    slug: "",
  });
  const [allChannelChatWithMsg, setAllChannelChatWithMsg] = useState([]);

  useEffect(() => {
    if (createNewChannelSection === 0) {
      setNewChannel({
        channelName: "",
        description: "",
        image: null,
        isPublic: false,
        slug: "",
      });
    }
  }, [createNewChannelSection]);

  useEffect(() => {
    if (createNewChannelSection == 3 && userSearch) fetchAllUser(1, "");
  }, [createNewChannelSection]);

  const handleSelectChat = (user) => {
    const alreadySelected = selectedChats.find((u) => u._id === user._id);
    if (alreadySelected) {
      setSelectedChats((prev) => prev.filter((u) => u._id !== user._id));
    } else {
      setSelectedChats((prev) => [...prev, user]);
    }
  };

  const handleRemoveSelected = (id) => {
    setSelectedChats((prev) => prev.filter((chat) => chat._id !== id));
  };

  const getIdStringFromArray = (data) => {
    return data.map((item) => item._id).join(",");
  };

  const handleNewChannelDone = async () => {
    const idString = getIdStringFromArray(selectedChats);
    const formData = new FormData();
    formData.append("channelName", newChannel.channelName);
    formData.append("description", newChannel.description);
    formData.append("users", idString);
    newChannel.image && formData.append("messageMedia", newChannel.image);
    formData.append("isPublic", newChannel.isPublic);
    formData.append("slug", newChannel.slug);

    const endPoint = "channel/create";
    const response = await postFormDataApiCaller(endPoint, formData);
    if (response?.status === 201) {
      setCreateNewChannelSection(0);
      setMoreNewChat(false);
      setSelectedChats([]);
      setNewChannel({
        channelName: "",
        description: "",
        image: null,
      });
      onChannelSelect(response?.data?.data);
      fetchChannels(true);
      fetchAllUser(1, "");
      toast.success("Channel created successfully");
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
  };

  const followChannel = async (channel) => {
    const endPoint = `channel/subscribe/${channel._id}`;
    const response = await postApiCaller(endPoint, {});
    if (response?.status === 200) {
      // onChannelSelect(channel);
      fetchChannels(true);
      channel.users = [userInfo, ...channel.users];
      onChannelSelect(channel);
      toast.success("Channel followed successfully");
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
  };

  const getAllMessages = useCallback(async () => {
    if (!userInfo?.encryptedPrivateKey) return;
    return await Promise.all(
      channels.map(async (msg) => {
        const IsFollowed = msg?.users?.some(
          (subscriber) => subscriber._id === userInfo?._id
        );
        if (!IsFollowed) {
          return msg;
        }

        const getSecretKey = await decryptText(
          msg?.conversationId?.AESKeyOfUser,
          userInfo?.encryptedPrivateKey
        );
        if (msg?.latestMessage?.cipherText) {
          try {
            const decryptedText = await decryptMessage(
              msg?.latestMessage?.cipherText,
              msg.latestMessage.iv,
              getSecretKey
            );

            return {
              ...msg,
              latestMessage: {
                ...msg.latestMessage,
                cipherText: decryptedText,
              },
            };
          } catch (err) {
            console.error("Decryption failed:", err);
            return {
              ...msg,
              latestMessage: {
                ...msg.latestMessage,
                cipherText: "",
              },
            };
          }
        }
        return msg;
      })
    );
  }, [channels, userInfo]);

  useEffect(() => {
    if (!userInfo?.encryptedPrivateKey) return;

    (async () => {
      const messages = await getAllMessages();
      if (messages) {
        // Sort messages by sentTime
        const sortedMessages = messages.sort((a, b) => {
          const timeA = a.latestMessage?.sentTime || a.sortTime;
          const timeB = b.latestMessage?.sentTime || b.sortTime;
          return new Date(timeB) - new Date(timeA);
        });
        setAllChannelChatWithMsg(sortedMessages);
      }
    })();
  }, [getAllMessages, channels]);

  return (
    <section className="w-full">
      {createNewChannelSection === 1 ||
      createNewChannelSection === 2 ||
      createNewChannelSection === 3 ? (
        <AddChannel
          createNewChannelSection={createNewChannelSection}
          setCreateNewChannelSection={setCreateNewChannelSection}
        />
      ) : createNewChannelSection === 4 ? (
        <AddSubscriber
          setCreateNewChannelSection={setCreateNewChannelSection}
        />
      ) : (
        <SingleChatSideBarHeader
          moreNewChat={moreNewChat}
          setMoreNewChat={() => {
            setCreateNewChannelSection(1);
          }}
        />
      )}
      <div>
        {createNewChannelSection == 0 && (
          <div className="m-4">
            <GroupChatSearch
              search={search}
              fetchChannels={fetchChannels}
              fetchAllUser={fetchAllUser}
              createNewChannelSection={createNewChannelSection}
            />
          </div>
        )}
        {createNewChannelSection == 4 && (
          <div className="m-4">
            <GroupChatSearch
              search={""}
              fetchChannels={fetchChannels}
              fetchAllUser={fetchAllUser}
              createNewChannelSection={createNewChannelSection}
            />
          </div>
        )}
        <div
          className={`p-4 pr-3 pt-0 ${
            createNewChannelSection === 0 && channels.length === 0 && !isLoading
              ? ""
              : "flex flex-col overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200"
          }`}
          style={{
            height:
              createNewChannelSection === 1
                ? "calc(100vh - 80px)"
                : createNewChannelSection === 4
                ? selectedChats.length > 0
                  ? "calc(100vh - 230px)"
                  : "calc(100vh - 150px)"
                : "calc(100vh - 150px)",
            minHeight:
              createNewChannelSection === 1
                ? "calc(100vh - 80px)"
                : createNewChannelSection === 4
                ? selectedChats.length > 0
                  ? "calc(100vh - 230px)"
                  : "calc(100vh - 150px)"
                : "calc(100vh - 150px)",
            maxHeight:
              createNewChannelSection === 1
                ? "calc(100vh - 80px)"
                : createNewChannelSection === 4
                ? selectedChats.length > 0
                  ? "calc(100vh - 230px)"
                  : "calc(100vh - 150px)"
                : "calc(100vh - 150px)",
          }}
        >
          {createNewChannelSection === 4 && (
            <SelectedChatAvatars
              selectedChats={selectedChats}
              handleRemoveSelected={handleRemoveSelected}
            />
          )}
          {moreNewChat && (
            <ChatListHeader
              setCreateNewChannelSection={setCreateNewChannelSection}
              type="Channel"
              setMoreNewChat={setMoreNewChat}
            />
          )}
          {createNewChannelSection === 0 && (
            <>
              {isLoading ? (
                <div className="h-[calc(100vh-220px)] content-center justify-items-center">
                  <FadeLoader color="#7104F8" loading={true} size={12} />
                </div>
              ) : channels.length === 0 ? (
                <div className="min-h-[calc(100dvh-150px)] content-center justify-items-center">
                  <p className="text-[#7104F8] font-semibold text-xl mb-16">
                    Channel Not Found
                  </p>
                </div>
              ) : (
                <InfiniteScroll
                  dataLength={allChannelChatWithMsg.length} //This is important field to render the next data
                  next={() => fetchChannels(true, currentPage + 1)}
                  hasMore={totalPages > currentPage}
                  loader={<p className="text-center">Loading...</p>}
                >
                  {allChannelChatWithMsg.map((item) => (
                    <ChatListItem
                      setIsMessageLoading={setIsMessageLoading}
                      totalFollowers={item?.users?.length}
                      key={item._id}
                      channel={item}
                      onChannelSelect={onChannelSelect}
                      followChannel={followChannel}
                      channelActiveChat={channelActiveChat}
                    />
                  ))}
                </InfiniteScroll>
              )}
            </>
          )}
          {createNewChannelSection === 4 && (
            <>
              {AllUser?.length > 0 && (
                <InfiniteScroll
                  dataLength={AllUser.length}
                  next={() => fetchAllUser(allUserCurrentPage + 1, "")}
                  hasMore={allUserCurrentPage < allUserTotalPages}
                  loader={<p className="text-center">Loading...</p>}
                >
                  {AllUser.map((item) => (
                    <AllUserList
                      key={item._id}
                      users={item}
                      selected={selectedChats.some((u) => u._id === item._id)}
                      handleSelectChat={handleSelectChat}
                    />
                  ))}
                </InfiniteScroll>
              )}
              {AllUser.length <= 0 && (
                <div className="flex-grow flex items-center justify-center h-full">
                  <p className="text-[#7104F8] font-semibold">
                    Follower Not Found
                  </p>
                </div>
              )}
            </>
          )}
          {createNewChannelSection === 1 && (
            <CreateChannel
              setCreateNewChannelSection={setCreateNewChannelSection}
              newChannel={newChannel}
              setNewChannel={setNewChannel}
            />
          )}
          {createNewChannelSection === 2 && (
            <ChannelUpload
              setCreateNewChannelSection={setCreateNewChannelSection}
              newChannel={newChannel}
              setNewChannel={setNewChannel}
              setSelectedChats={setSelectedChats}
            />
          )}
          {createNewChannelSection === 3 && (
            <ChannelType
              setCreateNewChannelSection={setCreateNewChannelSection}
              newChannel={newChannel}
              setNewChannel={setNewChannel}
              setSelectedChats={setSelectedChats}
            />
          )}
        </div>
        <div className="m-4">
          {createNewChannelSection === 4 && selectedChats.length > 0 && (
            <>
              <ChatListFooter onDone={() => handleNewChannelDone()} />
            </>
          )}
        </div>
      </div>
    </section>
  );
}
